export default __webpack_public_path__ + "static/media/loading.bcbae04e.gif";